export default __webpack_public_path__ + "static/media/workshop1.71f2091b.jpg";